<script>
import Endpoints from '../../../../../components/common/Endpoints';
import Common from '../../../../../components/common/Common';
import Request from '../../../../../components/common/Request';
import { mapActions } from 'vuex'
import jsPDF from 'jspdf'

export default {
    init: (payload) => {
        const el = document.body;
        el.removeAttribute("class");
        $('.modal').modal('hide');
        
        payload.dayBegin = new Date().getUTCDate();
        payload.monthBegin = new Date().getUTCMonth();
        payload.yearBegin = new Date().getUTCFullYear();

        payload.dayEnd = new Date().getUTCDate();
        payload.monthEnd = new Date().getUTCMonth();
        payload.yearEnd = new Date().getUTCFullYear();

        payload.daysInMonthBegin(payload.monthBegin,payload.yearBegin);
        payload.daysInMonthEnd(payload.monthEnd,payload.yearEnd);
        payload.filters.company =  payload.$session.get('user').companyUser.company._id;
        
        payload.filter();


    },
    methods:{
        filter: function(){
            
            let state = this;
            state.items = [];
           
            this.filters.beginDate = this.formatDateBegin(this.dayBegin,this.monthBegin,this.yearBegin);
            this.filters.endDate = this.formatDateEnd(this.dayEnd,this.monthEnd,this.yearEnd);
            
            Request.do(state, 'POST', Request.getDefaultHeader(state), this.filters, `${Endpoints.orders.holder.listOrdersByStatus}`,
            (response)=>{//SUCCESS CALLBACK
                state.items = response.results;
              
                state.totalOrders = state.items.length;
            },
            (error)=>{//ERROR CALLBACK
            });

           
        
        },
        checkForm: function(e){
            this.errors = [];
            this.items=[];
            if (this.filters.beginDate > this.filters.endDate){
                this.errors.push(this.$t('response.orders.filter.day.required'));
            }
            if (this.errors.length>0){
                 e.preventDefault();
            }else{
                this.filter();
            }

        },
        formatDateBegin: function(day,month,year){
                let date = new Date();
                date.setUTCDate(day);
                date.setUTCMonth(month); 
                date.setUTCFullYear(year);
                date.setUTCHours(0,0,0,0);
                return date.toISOString();
        },

        formatDateEnd: function(day,month,year){
                let date = new Date();
                date.setUTCDate(day);
                date.setUTCMonth(month); 
                date.setUTCFullYear(year);
                date.setUTCHours(23,59,59,999);
                return date.toISOString();
        },
       daysInMonthBegin: function(month, year) { 
           this.daysBegin = [];
            let nDay = new Date(year, month, 0).getDate();
            for(let i = 0; i < nDay ; i ++){
                this.daysBegin.push({day:i+1});
            } 
          
         },

        daysInMonthEnd: function(month, year) { 
            this.daysEnd = [];
            let nDay = new Date(year, month, 0).getDate();
            for(let i = 0; i < nDay ; i ++){
                this.daysEnd.push({day:i+1});
            } 
          
        },
        
        RefreshScreen: function(){
            this.$forceUpdate();
        },
        onChangeDay: function(){
            this.filters.beginDate =  new Date().setDate(new Date().getDate() - this.nDays),
            this.filters.endDate = new Date();
            this.filter();
             
        },
        fetchData(){
            this.json_data = this.items;
            return this.json_data;
        },
        // selectItem: function(item){
        //         this.order = item;
        //         console.log(item.systemUser._id);
        //         Request.do(this, 'POST', Request.getDefaultHeader(this), {systemUser:item.systemUser._id}, `${Endpoints.trucks.listByType}`,
        //         (response)=>{//SUCCESS CALLBACK
        //             this.trucks = response.results;
        //         },
        //         (error)=>{//ERROR CALLBACK
        //         return null;
        //         });
          
        //         setTimeout(async function(){
        //             $('#modalOrderCertified').modal('show');
        //         }, 100);
                
        // },
        selectItem: function(item){
                this.order = item;
               
                setTimeout(async function(){
                    $('#modalOrderService').modal('show');
                }, 100);
       },
       checkClose: function(item){
            return (item.statusOrder.toUpperCase() != 'CLOSED' && item.statusOrder.toUpperCase() != 'PAID' && item.statusOrder.toUpperCase() != 'REJECTED' )
            return null;
        },
        confirmArchive: function(item){
            this.titleToast = this.$t("string.msg.confirm");
            this.messageToast = this.$t("response.close.order.confirmation");
            this.cancelText = this.$t("string.msg.cancel");
            this.yesText = this.$t("string.msg.yes");
            this.orderSelected = item;
            console.log( this.orderSelected);

            setTimeout(async function(){
                $('#confirmationCloseHolderService').modal('show');
                }, 100);
        },
        archive: function(response){
            if (response==1){
                $('#spinner').modal('toggle');
                this.errors = [];
                this.messageIdToast = null;
                let state = this;
                
                Request.do(this, 'POST', Request.getDefaultHeader(this), {isCloseAllOrders:true} , `${Endpoints.orders.closeholder}${this.orderSelected._id}`,
                    (companyResponse)=>{//SUCCESS CALLBACK

                        $('#spinner').modal('toggle');
                    },
                    (error)=>{//ERROR CALLBACK
                        $('#spinner').modal('toggle');
                        let res = error.response;
                        if (res && res.status){
                            this.titleToast = this.$t("string.msg.warning");
                            if (res.data.messageId === 'response.msg.error.empty.fields'){
                                let fields = "";
                                res.data.errors.forEach(function (value) {
                                    fields += state.$t(value.id)+";<br/>";
                                });
                                this.titleToast = this.$t(res.data.messageId);
                                this.messageToast = this.$t(fields);
                            }else{
                                this.messageToast = this.$t(res.data.messageId);
                                this.messageIdToast = res.data.messageId;
                            }

                            $('#toast').modal('show');
                        }
                        console.log(JSON.stringify(error));
                });
            }
        },
        download: function(item){

            // var getImageFromUrl = function(url, callback) {
            //     var img = new Image, data, ret={data: null, pending: true};
                
            //     img.onError = function() {
            //         throw new Error('Cannot load image: "'+url+'"');
            //     }
            //     img.onload = function() {
            //         var canvas = document.createElement('canvas');
            //         document.body.appendChild(canvas);
            //         canvas.width = img.width;
            //         canvas.height = img.height;

            //         var ctx = canvas.getContext('2d');
            //         ctx.drawImage(img, 0, 0);
            //         // Grab the image as a jpeg encoded in base64, but only the data
            //         data = canvas.toDataURL('image/jpeg').slice('data:image/jpeg;base64,'.length);
            //         // Convert the data to binary form
            //         data = atob(data)
            //         document.body.removeChild(canvas);

            //         ret['data'] = data;
            //         ret['pending'] = false;
            //         if (typeof callback === 'function') {
            //             callback(data);
            //         }
            //     }
            //     img.src = url;

            //     return ret;
            // }
            

           
            let pdfName = 'certificado - '+String(item._id);
            var doc = new jsPDF();
            let total = item.paymentObject.amount_br.toString();
            let companyAddress = item.company.address.address + ' ' + item.company.address.number + ', ' + item.company.address.neighborhood +
             ' ' + item.company.address.cep + ', ' + item.company.address.city + ' - ' + item.company.address.state;  
            let customerName = "";
            if(item.systemUser.firstName!=null)
            { customerName = item.systemUser.firstName;}
            if(item.systemUser.lastName!=null)
            { customerName = customerName + ' ' + item.systemUser.lastName; }
            
            
            console.log(this.nameItem);
            doc.setProperties({
                title: 'Certificado',
                subject: 'Certificado',		
                author:  item.company.socialName,
                keywords: 'generated, javascript, web 2.0, ajax',
                creator: 'SOS Truck'
            });
         
            doc.setFontSize(20);
            doc.text(15, 15, this.$t('string.text.order.paid.recive'));	
            doc.text(130, 15, this.$t('string.text.order.paid.number.order'));
            doc.setFontSize(12);
            doc.setTextColor(0);
            doc.text(15, 40, this.$t('string.text.order.paid.by'));
            doc.text(15, 55, this.$t('string.text.order.delivery.options'));
            doc.text(15, 80, this.$t('string.text.order.company'));
            doc.setFontSize(10);
            doc.text(130,80, this.$t('string.text.order.status') + ' ' + this.toUpperCase(this.$t(item.transactionStatusCode)));		
            doc.setFontSize(12);
            doc.text(130, 40, this.$t('string.text.order.details'));
            doc.setFontSize(20);
            doc.text(130, 60, this.$t('string.text.order.paid.total'));
            doc.text(165, 60, String(total));	
            doc.setFontSize(12);
            doc.setTextColor(120);
            doc.text(130, 21, String(item._id));	
            doc.setFontSize(8);
            doc.text(130, 45, String(item.certified.name));	
            doc.setFontSize(12);
            doc.text(130, 66, String(this.$t(item.paymentMethod)));
             doc.text(130, 71, String(this.$t(item.paymentType)));
            doc.text(15, 60, String(this.$t(item.deliveryMethod)));	
            doc.text(15, 85, String(item.company.socialName));
            doc.setFontSize(10);	
            doc.text(15, 90,companyAddress);
            doc.text(15, 95,item.company.primaryPhone + ' - ' + item.company.email);
            doc.setFontSize(12);
            doc.text(15, 45, String(customerName));
            doc.text(15, 21, this.$t('string.text.order.date'));
            doc.text(57, 21, String(item.paymentObject.confirm_date));
            doc.text(165, 45,String(total));
            doc.save(pdfName + '.pdf');

        },
        onChange: function(){
            this.filter();
        },
        camelize: Common.camelize,
        toUpperCase: Common.toUpperCase,
    }
}
</script>